import React, { Component } from 'react';
import {reduxForm, Field} from 'redux-form';
import {FormattedHTMLMessage} from 'react-intl';
import generateValidator from './Validations/generateValidator';
import asyncValidate from './Validations/asyncValidationsLoanDescriptionForm';
import withAuthControl from '../auth/Auth.js';
import TopScrolleable from './TopScrolleable.js';
import Section from './Section.js';
import CustomSpinner from './CustomSpinner';
import CustomAlert from './CustomAlert.js';
import RenderField from './RenderField';
import SaveStepButton from './SaveStepButton';
import axios from 'axios';
import { formatMoney } from '../utils/utils.js';
import LoadField from '../components/LoadField';

class LoanDescriptionForm extends Component {

    constructor(props) {
        super(props);
        this.state = { amount_total: null,
                        term: null,
                        frequency: null,
                        amount_approved: null
                    };
    }

    componentDidMount() {
        const ROOT_URL = process.env.API_URL;
        const config = {
            headers:
                {
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + sessionStorage.getItem('jwtToken')
                }
        };
        axios.get(`${ROOT_URL}/steps/param?param=amount_approved`, config).then((response)=> {
            this.setState({
                amount_approved: response.data.amount_approved,
            });
        });
    }

    render() {
        const { handleSubmit, submitting, error } = this.props;
        const { amount_approved } = this.state;

        return (
            <Section className="intro_form">
                <div className="row">
                    <div className="pd-content-left col-md-5 col-lg-5 text-center">
                        <img alt="Logo" className="center-block intro_logo" src={require(`../assets/${process.env.PAGE}/img/logo-h-blanco.png`)}/>
                        <FormattedHTMLMessage id="app.step_loan_description" description="Load Description"/>
                        <div className="show-desktop">
                            <SaveStepButton/>
                        </div>
                    </div>
                    <div className="pd-content-right short-content col-sm-12 col-md-7 col-lg-7">
                        <form onSubmit={handleSubmit(this.props.saveLoanDescriptionForm)} className="pvc-form">
                            {this.props.isLoading && <CustomSpinner message='Estamos analizando tu solicitud. Por favor esperá...' /> }
                            {/*error && <CustomAlert bsStyle="danger" message={error}/>*/}
                            <div style={{textAlign: 'center'}}>
                                <FormattedHTMLMessage id="app.step_available_amount" description="Available Amount info"/>
                                <LoadField>
                                    { amount_approved ? (<div className={'available-amount'}>{`${formatMoney(amount_approved, 0 , ',', '.')}`}</div>) : null }
                                </LoadField>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12">
                                    <div className={error ? "form-group has-error" : "form-group"}>
                                        <div className="help-block">
                                        <Field className="form-control" name="requested_amount" autoComplete="off" component={RenderField}  type="currency" label="Monto a financiar en pesos"/>
                                            {((error && <span>{'Valor no valido'}</span>))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-sm-12 col-md-12 col-lg-12 text-center">
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form" disabled={submitting}>Continuar</button>
                                </div>
                            </div>
                        </form>
                        <div className="show-mobile">
                            <SaveStepButton/>
                        </div>
                    </div>
                </div>
            </Section>
        );
    }
}

LoanDescriptionForm.contextTypes = {
    intl: React.PropTypes.object.isRequired
}

let validate = generateValidator([{name: 'requested_amount', required: true}]);

LoanDescriptionForm = TopScrolleable(LoanDescriptionForm);

LoanDescriptionForm = reduxForm({
    form: 'LoanDescription', // a unique name for this form
    validate
})(LoanDescriptionForm);

LoanDescriptionForm = withAuthControl(LoanDescriptionForm);

export default LoanDescriptionForm;


/** WEBPACK FOOTER **
 ** ./src/components/LoanDescriptionForm.js
 **/